import { FeePricingType, FeeQuantitySource } from '../api/feeCategoriesApi';

export interface FeeCategoryBillingLabelInput {
  pricingType?: FeePricingType | string;
  isMonthlyFixed?: boolean;
  quantitySource?: FeeQuantitySource | string;
  name?: string;
  feeCode?: string | null;
}

export function isMeterBasedFeeCategory(feeCategory: FeeCategoryBillingLabelInput): boolean {
  const code = (feeCategory.feeCode ?? '').trim().toUpperCase();
  if (code.startsWith('XE') || code.startsWith('SAC')) {
    return false;
  }

  if (feeCategory.pricingType === FeePricingType.TIERED || feeCategory.pricingType === 'TIERED') {
    return true;
  }

  const name = (feeCategory.name || '').toLowerCase();
  if (name.includes('gửi xe') || name.includes('gui xe')) {
    return false;
  }
  if (name.includes('phí sạc') || name.includes('phi sac')) {
    return false;
  }
  return name.includes('điện') || name.includes('nước');
}

export function getFeeCategoryBillingLabel(feeCategory: FeeCategoryBillingLabelInput): string {
  if (isMeterBasedFeeCategory(feeCategory)) {
    return 'Theo chỉ số';
  }
  if (feeCategory.quantitySource === FeeQuantitySource.APARTMENT_AREA || feeCategory.quantitySource === 'APARTMENT_AREA') {
    return 'Theo diện tích';
  }
  if (feeCategory.isMonthlyFixed || feeCategory.pricingType === FeePricingType.SINGLE_TIER) {
    return 'Cố định';
  }
  return 'Cố định';
}
